import { footballOnServeHandler, createBaseballShortLabel, baseBallOnServeHandler, createAmricanFootbalShortLabel, createAdditionalScoresBaseball, geTeamsScoreTennis, getTennisLabels, getBasketballLabels, getSoccerLabels } from "./helpers";
export const numberMap = {
    0: "",
    1: "First",
    2: "Second",
    3: "Third"
};
/**
 * Specifies map with key sportID and different labels and handlers
 * to handle the differences of creating the data for the UI
 */
export const sportIdMapConfig = {
    1: {
        getTeamsScoreLabelsHandler: getSoccerLabels,
    },
    2: {
        getTeamsScoreLabelsHandler: getBasketballLabels,
    },
    3: {
        createShortLabelHandler: createAmricanFootbalShortLabel,
        onServeHandler: footballOnServeHandler,
    },
    6: {
        getTeamsScoreLabelsHandler: getTennisLabels,
        getTeamsScoreHandler: geTeamsScoreTennis,
    },
    7: {
        createShortLabelHandler: createBaseballShortLabel,
        createAdditionalScores: createAdditionalScoresBaseball,
        labelsKeys: ["Runs", "Hits"],
        onServeHandler: baseBallOnServeHandler,
        decreaseIndexResult: 2,
    },
    19: {
        labelsKeys: [""],
    },
    59: {
        labelsKeys: [""],
    }
};
//# sourceMappingURL=config.js.map